module.exports = __webpack_public_path__ + "assets/img/step7-sz.e681bc91.png";